import api from "../../../shared/api.jsx";

/**
 * Lead Flow Progress Service - API calls for real-time lead flow progress tracking
 */

/**
 * Get real-time lead flow progress data
 * @returns {Promise<Object>} Lead flow progress data
 */
export const getLeadFlowProgress = async () => {
  try {
    const response = await api.get("/analytics/leads/progress");
    return response;
  } catch (error) {
    console.error("Error fetching lead flow progress:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch lead flow progress",
      data: {
        totalActiveUsers: 0,
        stepDistribution: {},
        completionMetrics: {},
        stuckUsers: [],
        engagementMetrics: {},
        lastUpdated: new Date().toISOString(),
      },
    };
  }
};

/**
 * Get lead flow progress summary (lightweight version)
 * @returns {Promise<Object>} Lead flow progress summary
 */
export const getLeadFlowProgressSummary = async () => {
  try {
    const response = await api.get("/analytics/leads/progress/summary");
    return response;
  } catch (error) {
    console.error("Error fetching lead flow progress summary:", error);
    return {
      success: false,
      error: error.message || "Failed to fetch lead flow progress summary",
      data: {
        totalActiveUsers: 0,
        topSteps: [],
        completionRate: 0,
        stuckUsers: 0,
        lastUpdated: new Date().toISOString(),
      },
    };
  }
};
